// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimQuestion from '@deere/cps-it.warranty-model-factory/lib/claim-question';
import ClaimQuestionDropdown from './claim-question-dropdown';
import EditableField from '../../../../shared/components/editable-field';

const findValue = (choice, list) => {

    const item = list.find(listItem => choice === listItem.key);

    return item ? item.value : '';

};

const ClaimQuestionDropdownContainer = props =>
    <EditableField
        isEditable={props.isEditable}
        value={findValue(props.selectedValue.choice, props.list)}
    >
        <ClaimQuestionDropdown
            {...props}
            className={props.className}
            value={props.selectedValue.choice}
        />
    </EditableField>;

ClaimQuestionDropdownContainer.displayName = 'ClaimQuestionDropdownContainer';
ClaimQuestionDropdownContainer.propTypes = {
    className: PropTypes.string.isRequired,
    isEditable: PropTypes.bool.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(ClaimQuestion)).isRequired,
    selectedValue: PropTypes.instanceOf(ClaimQuestion).isRequired
};

export default ClaimQuestionDropdownContainer;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/claim-question-dropdown-container.js